const SPECIFIC_ADVOCATE_IDS_FILTER = {
  "category": "specificAdvocateIds",
  "conjunction": {
    "name": "and"
  }
};

const NO_FILTER_COOKIE = "";


export default {
  showOfficialsOptions: ["contacted", "emailed", "tweeted", "called"],
  chainableFilters: [
    {name: "campaign_activity", limit: 5, limited: true},
    {name: "tags", limit: 5, limited: true},
    {name: "location", limit: 5, limited: true},
    {name: "created_on", limit: 1, limited: false},
    {name: "join_date", limit: 1, limited: false},
    {name: "optin", limit: 2, limited: true},
    {name: "email_activity", limit: 5, limited: true},
    {name: "stages", limit: 1, limited: false},
    {name: "sources", limit: 1, limited: false}
  ],
  SPECIFIC_ADVOCATE_IDS_FILTER,
  NO_FILTER_COOKIE
}